<button class="button fill--{{_fill}} color--{{_color}}" [type]="_type" [attr.form]="_form" [disabled]="_disabled"
  [attr.aria-label]="ariaLabel || null"
  (click)="handleClick($event)">
  <span *ngIf="_prefix" class="prefix material-symbols-outlined" aria-hidden="true">{{_prefix}}</span>

  <div class="label">
    <ng-content></ng-content>
  </div>

  <span *ngIf="_suffix" class="suffix material-symbols-outlined" aria-hidden="true">{{_suffix}}</span>
</button>